import { z } from 'zod';
import { FocusArea } from 'libs/end-to-end/src/focus-area';

export const OverviewPageConfigurationType = z.enum([
  'default',
  'custom',
  'no-intelligence',
]);

export type OverviewPageConfigurationType = z.infer<
  typeof OverviewPageConfigurationType
>;

export const OverviewPageConfigurationTypes = Object.values(
  OverviewPageConfigurationType.Values,
);

export const OverviewPageDefaultConfiguration = z.object({
  type: z.literal('default'),
});

export type OverviewPageDefaultConfiguration = z.infer<
  typeof OverviewPageDefaultConfiguration
>;

export const OverviewPageCustomDashboardConfiguration = z.object({
  type: z.literal('custom'),
  configuration: z.object({
    focusAreaId: FocusArea,
    modelVersion: z.literal('v1'),
    primaryFilterId: z.string(),
    primaryFilterSelection: z.string(),
    secondaryFilterId: z.string(),
  }),
});

export type OverviewPageCustomDashboardConfiguration = z.infer<
  typeof OverviewPageCustomDashboardConfiguration
>;

export const OverviewPageNoIntelligenceConfiguration = z
  .object({
    type: z.literal('no-intelligence'),
  })
  .describe('OverviewPageNoIntelligenceConfiguration');

export type OverviewPageNoIntelligenceConfiguration = z.infer<
  typeof OverviewPageNoIntelligenceConfiguration
>;

export const OverviewPageConfiguration = z.union([
  OverviewPageDefaultConfiguration,
  OverviewPageCustomDashboardConfiguration,
  OverviewPageNoIntelligenceConfiguration,
]);

export type OverviewPageConfiguration = z.infer<
  typeof OverviewPageConfiguration
>;

export const OverviewPageConfigurationRequest = z.object({
  configuration: OverviewPageConfiguration,
});

export type OverviewPageConfigurationRequest = z.infer<
  typeof OverviewPageConfigurationRequest
>;
